import { WorkflowTranslator } from 'src/translators'
import { WorkflowFormEntity } from 'src/types'
import { useCreateWorkflowMutation } from 'src/types/generated'

type CreateInput = {
  formEntity: WorkflowFormEntity
}

export const useWorkflow = () => {
  const [createWorkflowMutation] = useCreateWorkflowMutation()

  const createWorkflow = async ({ formEntity }: CreateInput): Promise<void> => {
    const params = WorkflowTranslator.toRequest(formEntity)
    await createWorkflowMutation({ variables: { params } })
  }

  return {
    createWorkflow,
  }
}
